import React, { useEffect, useState } from "react";

import TabContent from "./tabContent";
import TabHeader from "./tabHeader";

function TabsWrapper(props) {
  const {
    tabs,
    defaultSelectedTab,
    updateSelectedTab = () => {},
    standalone = true,
    isVertical = true,
    additionalContainerClass = "",
    additionalHeaderClass = "",
    additionalContentClass = "",
    additionalHeaderTabClasses = "",
    additionalContentTabClasses = ""
  } = props;

  const [activeTabId, setActiveTabId] = useState(
    standalone ? defaultSelectedTab || 0 : defaultSelectedTab
  );

  function btnClick(id) {
    standalone ? setActiveTabId(id) : updateSelectedTab(id);
  }

  useEffect(() => {
    !standalone && setActiveTabId(defaultSelectedTab);
  }, [defaultSelectedTab, standalone]);

  const layout = isVertical ? "vertical" : "horizontal";
  const orientationOpts = {
    vertical: {
      container: "w-full flex gap-x-3",
      headerContainer: "w-1/4 tab-header-wrapper-container",
      contentContainer: "w-3/4 tab-content-wrapper-container"
    },
    horizontal: {
      container: "w-full flex flex-col",
      headerContainer:
        "w-full overflow-y-visible overflow-x-auto h-14 flex gap-x-20 border-b-1 border-black-lighter planet:border-gray-lighter sm:overflow-visible sm:h-auto sm:gap-x-0 sm:w-full sm:gap-x-5 tab-header-wrapper-container",
      contentContainer:
        "w-full pt-20 bg-white planet:gvi-dark-gray-bg tab-content-wrapper-container"
    }
  };

  return (
    <>
      <div
        className={`${orientationOpts[layout]?.container} ${additionalContainerClass}`}
      >
        <div
          className={`${orientationOpts[layout]?.headerContainer} ${additionalHeaderClass}`}
        >
          {tabs?.map((tab, index) => (
            <TabHeader
              key={tab?.id}
              onClick={btnClick}
              item={tab}
              idx={tab?.id}
              activeTabId={activeTabId}
              isVertical={isVertical}
              additionalHeaderTabClasses={additionalHeaderTabClasses}
            />
          ))}
        </div>
        <div
          className={`${orientationOpts[layout]?.contentContainer} ${additionalContentClass}`}
        >
          {tabs?.map((tab, index) => (
            <TabContent
              item={tab}
              key={tab?.id}
              idx={tab?.id}
              activeTabId={activeTabId}
              isVertical={isVertical}
              additionalClasses={additionalContentTabClasses}
            />
          ))}
        </div>

        {props.children}
      </div>
      <span className={`chosen-tab ${activeTabId} gap-`}>&nbsp;</span>
    </>
  );
}
export default TabsWrapper;
